package app.bloomey.web.utils

class ApiError(override val message: String, cause: Throwable? = null) : Exception(message, cause) {
    companion object {
        fun parseMessage(e: Throwable, fallback: String? = null): String {
            if (e is ApiError) {
                return e.message
            }
            return fallback ?: "App Error"
        }
    }
}